export default __webpack_public_path__ + "static/media/26_photo.3dc288d8.jpeg";